import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02fc8bab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col text-end" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Type")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col text-end" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Value")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col text-end" })
  ])
], -1))
const _hoisted_3 = { class: "" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = {
  key: 0,
  class: "variable-pop-up"
}
const _hoisted_9 = {
  key: 1,
  class: "variable-pop-up"
}
const _hoisted_10 = {
  key: 2,
  class: "variable-pop-up"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_EditVariable = _resolveComponent("EditVariable")!
  const _component_RemoveVariable = _resolveComponent("RemoveVariable")!
  const _component_AddVariable = _resolveComponent("AddVariable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.variables), (key) => {
          return (_openBlock(), _createElementBlock("tr", { key: key }, [
            _createElementVNode("td", null, _toDisplayString(_ctx.variables[key].name), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.variables[key].type), 1),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_3, [
                (_ctx.variables[key].type === 'LINK')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: _ctx.variables[key].value
                      }, _toDisplayString(_ctx.variables[key].label || _ctx.variables[key].value), 9, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.variables[key].type !== 'LINK')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.variables[key].value), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_feather_icon, {
                type: "edit",
                class: "me-2 cursor-pointer",
                size: "16",
                onClick: ($event: any) => {_ctx.updateVariable = true; _ctx.selectedVar = _ctx.variables[key]; _ctx.selecteVarId = key;}
              }, null, 8, ["onClick"]),
              _createVNode(_component_feather_icon, {
                type: "trash",
                class: "cursor-pointer",
                size: "16",
                onClick: ($event: any) => {_ctx.deleteVariable = true; _ctx.selecteVarId = key; _ctx.selecteVarName = _ctx.variables[key].name;}
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: "btn btn-primary btn-sm float-end cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createVariable = true))
    }, "Add Variable "),
    (_ctx.updateVariable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_EditVariable, {
            id: _ctx.selecteVarId,
            selectedVar: _ctx.selectedVar,
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateVariable = false)),
            onUpdated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateVariable = false))
          }, null, 8, ["id", "selectedVar"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.deleteVariable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_RemoveVariable, {
            id: _ctx.selecteVarId,
            name: _ctx.selecteVarName,
            onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteVariable = false)),
            onDeleted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteVariable = false))
          }, null, 8, ["id", "name"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.createVariable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_AddVariable, {
            onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createVariable = false)),
            onAddVariable: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createVariable = false))
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}